// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IEventTriggerFactory {
	$type?: string | undefined;
}
export class EventTriggerFactory {
	constructor(data?: IEventTriggerFactory) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	static $type: string = "CoreApi.Models.EventTriggers.EventTriggerFactory, ";
	$type?: string | undefined = EventTriggerFactory.$type;
}

